import { observer } from "mobx-react";
import { FilterTag } from "../FilterTag";
import { useStores } from "../../../../../shared/stores/RootStore";

const HlaAttributeFiltersTagsBase = () => {
  const { filterStore } = useStores();
  const filters = filterStore.hlaAttributeFilters;

  return (
    <>
      {!!filters.type.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              type: [],
            })
          }
        >
          Road type ({filters.type.length})
        </FilterTag>
      )}

      {!!filters.heavyVehicleFlow.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              heavyVehicleFlow: [],
            })
          }
        >
          Heavy vehicle flow ({filters.heavyVehicleFlow.length})
        </FilterTag>
      )}

      {(!!filters.averageRoadSpeed.min || !!filters.averageRoadSpeed.max) && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              averageRoadSpeed: { min: null, max: null },
            })
          }
        >
          {`Average road speed from ${filters.averageRoadSpeed.min ?? "0"} to ${
            filters.averageRoadSpeed.max ?? "∞"
          }`}
        </FilterTag>
      )}

      {(!!filters.averageDailyTraffic.min ||
        !!filters.averageDailyTraffic.max) && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              averageDailyTraffic: { min: null, max: null },
            })
          }
        >
          {`Average daily traffic from ${
            filters.averageDailyTraffic.min ?? "0"
          } to ${filters.averageDailyTraffic.max ?? "∞"}`}
        </FilterTag>
      )}

      {!!filters.lit.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              lit: [],
            })
          }
        >
          Street lighting ({filters.lit.length})
        </FilterTag>
      )}

      {!!filters.facilityType.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              facilityType: [],
            })
          }
        >
          Facility type ({filters.facilityType.length})
        </FilterTag>
      )}

      {!!filters.flowDirection.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              flowDirection: [],
            })
          }
        >
          Flow direction ({filters.flowDirection.length})
        </FilterTag>
      )}

      {!!filters.facilityWidthPerDirection.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              facilityWidthPerDirection: [],
            })
          }
        >
          Facility width per direction (
          {filters.facilityWidthPerDirection.length})
        </FilterTag>
      )}

      {!!filters.lightSegregation.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              lightSegregation: [],
            })
          }
        >
          Light segregation ({filters.lightSegregation.length})
        </FilterTag>
      )}

      {!!filters.hardSegregation.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              hardSegregation: [],
            })
          }
        >
          Hard segregation ({filters.hardSegregation.length})
        </FilterTag>
      )}

      {!!filters.tramOrTrainRails.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              tramOrTrainRails: [],
            })
          }
        >
          Tram or train rails ({filters.tramOrTrainRails.length})
        </FilterTag>
      )}

      {!!filters.roadLane.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              roadLane: [],
            })
          }
        >
          Adjacent road lane ({filters.roadLane.length})
        </FilterTag>
      )}

      {!!filters.numberOfLanes.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              numberOfLanes: [],
            })
          }
        >
          Number of lanes ({filters.numberOfLanes.length})
        </FilterTag>
      )}

      {!!filters.vehicleParking.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              vehicleParking: [],
            })
          }
        >
          Adjacent parking ({filters.vehicleParking.length})
        </FilterTag>
      )}

      {!!filters.sidewalk.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              sidewalk: [],
            })
          }
        >
          Adjacent sidewalk ({filters.sidewalk.length})
        </FilterTag>
      )}

      {!!filters.objectOrLevelChange.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              objectOrLevelChange: [],
            })
          }
        >
          Adjacent object or level change ({filters.objectOrLevelChange.length})
        </FilterTag>
      )}

      {!!filters.severeHazard.length && (
        <FilterTag
          onClose={() =>
            filterStore.setHlaAttributeFilters({
              ...filters,
              severeHazard: [],
            })
          }
        >
          Adjacent severe hazard ({filters.severeHazard.length})
        </FilterTag>
      )}
    </>
  );
};

export const HlaAttributeFiltersTags = observer(HlaAttributeFiltersTagsBase);
